"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var __1 = require("..");
var core_1 = require("@material-ui/core");
var util_localization_1 = require("@sport-thieme/util-localization");
var utils_1 = require("./utils");
var SimpleTableRow_1 = __importDefault(require("./SimpleTableRow"));
var Table_1 = require("../Table");
exports.default = react_1.forwardRef(function SimpleTable(_a, ref) {
    var _b, _c, _d;
    var color = _a.color, colorCoefficient = _a.colorCoefficient, colorCoefficientDarkMode = _a.colorCoefficientDarkMode, paperProps = _a.paperProps, padding = _a.padding, size = _a.size, headerData = _a.headerData, bodyData = _a.bodyData, data = _a.data, _e = _a.alternateRowColors, alternateRowColors = _e === void 0 ? false : _e, disableHeaderFontTint = _a.disableHeaderFontTint, footerData = _a.footerData, tableContainerProps = _a.tableContainerProps, tableProps = _a.tableProps, stickyHeader = _a.stickyHeader, rowsPerPageOptions = _a.rowsPerPageOptions, _f = _a.disableAutoAlign, disableAutoAlign = _f === void 0 ? false : _f, _g = _a.disablePagination, disablePagination = _g === void 0 ? false : _g, _h = _a.noDataInformation, noDataInformation = _h === void 0 ? util_localization_1.localize(templateObject_1 || (templateObject_1 = __makeTemplateObject(["There is no content to display."], ["There is no content to display."]))) : _h, _j = _a.rowsPerPage, defaultRowsPerPage = _j === void 0 ? 10 : _j;
    var _k = react_1.useState(defaultRowsPerPage), rowsPerPage = _k[0], setRowsPerPage = _k[1];
    var _l = react_1.useState(0), page = _l[0], setPage = _l[1];
    var classes = useStyles({
        color: color,
        colorCoefficient: colorCoefficient,
        colorCoefficientDarkMode: colorCoefficientDarkMode,
        paperProps: paperProps,
        disableHeaderFontTint: disableHeaderFontTint,
    });
    react_1.useEffect(function () { return setRowsPerPage(defaultRowsPerPage); }, [defaultRowsPerPage]);
    /**
     * Data conversion
     */
    var tableXLength = 0;
    if (data && data.length !== 0) {
        var headerStrings_1 = Object.keys((_d = (_c = (_b = data[0]) === null || _b === void 0 ? void 0 : _b.main) !== null && _c !== void 0 ? _c : data[0]) !== null && _d !== void 0 ? _d : {});
        headerData = headerStrings_1;
        bodyData = data.map(function (entry) {
            if (utils_1.isCollapsible(entry)) {
                if (tableXLength < Object.keys(entry.main).length) {
                    tableXLength = Object.keys(entry.main).length + 1;
                }
                return {
                    main: headerStrings_1
                        .map(function (key) { return entry.main[key]; })
                        .filter(function (cellData) { return cellData !== undefined; }),
                    collapsible: entry.collapsible,
                };
            }
            else {
                if (tableXLength < Object.keys(entry).length) {
                    tableXLength = Object.keys(entry).length;
                }
                return headerStrings_1.map(function (key) { return entry[key]; }).filter(function (cellData) { return cellData !== undefined; });
            }
        });
    }
    var hasPagination = disablePagination === false && ((bodyData === null || bodyData === void 0 ? void 0 : bodyData.length) || 0) > rowsPerPage;
    var paginatedBodyData = bodyData;
    if (hasPagination) {
        paginatedBodyData = __spreadArrays((bodyData || [])).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
    }
    var emptyRows = rowsPerPage - Math.min(rowsPerPage, ((bodyData === null || bodyData === void 0 ? void 0 : bodyData.length) || 0) - page * rowsPerPage);
    return (jsx_runtime_1.jsxs(__1.Paper, __assign({}, paperProps, { ref: ref }, { children: [jsx_runtime_1.jsx(Table_1.TableContainer, __assign({}, tableContainerProps, { children: jsx_runtime_1.jsxs(__1.Table, __assign({}, __assign({ padding: padding, size: size, stickyHeader: stickyHeader }, tableProps), { children: [Boolean(headerData) && (jsx_runtime_1.jsx(__1.TableHead, __assign({ className: classes.tableHead }, { children: jsx_runtime_1.jsx(SimpleTableRow_1.default, { rowsData: [headerData], variant: 'head', tableXLength: tableXLength, disableAutoAlign: disableAutoAlign, alternateRowColors: alternateRowColors }, void 0) }), void 0)),
                        jsx_runtime_1.jsxs(__1.TableBody, { children: [((paginatedBodyData === null || paginatedBodyData === void 0 ? void 0 : paginatedBodyData.length) || 0) > 0 ? (jsx_runtime_1.jsx(SimpleTableRow_1.default, { rowsData: paginatedBodyData, variant: 'body', tableXLength: tableXLength, disableAutoAlign: disableAutoAlign, alternateRowColors: alternateRowColors }, void 0)) : (jsx_runtime_1.jsx(__1.TableRow, { children: jsx_runtime_1.jsx(__1.TableCell, __assign({ colSpan: headerData === null || headerData === void 0 ? void 0 : headerData.length, align: "center" }, { children: noDataInformation }), void 0) }, void 0)),
                                hasPagination &&
                                    emptyRows > 0 &&
                                    Array.from(new Array(emptyRows)).map(function (_, index) { return (jsx_runtime_1.jsx(__1.TableRow, { children: jsx_runtime_1.jsx(__1.TableCell, __assign({ colSpan: headerData === null || headerData === void 0 ? void 0 : headerData.length }, { children: "\u00A0" }), void 0) }, "empty-" + index)); })] }, void 0),
                        Boolean(footerData) && (jsx_runtime_1.jsx(__1.TableFooter, { children: jsx_runtime_1.jsx(SimpleTableRow_1.default, { rowsData: [footerData], variant: 'footer', tableXLength: tableXLength, disableAutoAlign: disableAutoAlign, alternateRowColors: alternateRowColors }, void 0) }, void 0))] }), void 0) }), void 0),
            hasPagination && (jsx_runtime_1.jsx(__1.TablePagination, { rowsPerPageOptions: rowsPerPageOptions, count: (bodyData === null || bodyData === void 0 ? void 0 : bodyData.length) || 0, rowsPerPage: rowsPerPage, page: page, onChangePage: function (_, newPage) {
                    setPage(newPage);
                }, onChangeRowsPerPage: function (_a) {
                    var value = _a.target.value;
                    setRowsPerPage(parseInt(value, 10));
                    setPage(0);
                } }, void 0))] }), void 0));
});
var useStyles = core_1.makeStyles(function (theme) { return ({
    tableHead: {
        '& .MuiTableCell-head': {
            background: function (_a) {
                var color = _a.color, _b = _a.colorCoefficient, colorCoefficient = _b === void 0 ? 0.9 : _b, _c = _a.colorCoefficientDarkMode, colorCoefficientDarkMode = _c === void 0 ? 0.7 : _c;
                if (color !== undefined) {
                    return theme.palette.type === 'light'
                        ? core_1.lighten(theme.palette[color].main, colorCoefficient)
                        : core_1.darken(theme.palette[color].main, colorCoefficientDarkMode);
                }
                return theme.palette.background.paper;
            },
            color: function (_a) {
                var color = _a.color, _b = _a.disableHeaderFontTint, disableHeaderFontTint = _b === void 0 ? false : _b;
                if (disableHeaderFontTint) {
                    return undefined;
                }
                if (color !== undefined) {
                    return theme.palette[color].main;
                }
                return theme.palette.text.primary;
            },
        },
        '& .MuiTableCell-head:first-of-type': {
            borderTopLeftRadius: function (_a) {
                var paperProps = _a.paperProps;
                return ((paperProps === null || paperProps === void 0 ? void 0 : paperProps.square) ? 0 : theme.shape.borderRadius);
            },
        },
        '& .MuiTableCell-head:last-of-type': {
            borderTopRightRadius: function (_a) {
                var paperProps = _a.paperProps;
                return ((paperProps === null || paperProps === void 0 ? void 0 : paperProps.square) ? 0 : theme.shape.borderRadius);
            },
        },
    },
}); });
var templateObject_1;
//# sourceMappingURL=SimpleTable.js.map